// extracted by mini-css-extract-plugin
export default {"table":"ProductList_table__RICw4","link":"ProductList_link__tqJ03"};